// react
import React, { Suspense } from "react";

// components
import Spinner from "../../../../components/Spinner/ComponentLoader";

// load in the goal tree
const LazyReportAnalytics = React.lazy(() => import("./ReportAnalytics"));

const ReportAnalyticsLoader = () => {
	return (
		<Suspense fallback={<Spinner />}>
			<LazyReportAnalytics />
		</Suspense>
	);
};

export default ReportAnalyticsLoader;
